import { shortMonths, longMonths, weekdays } from '../commons/locales/es_ES';
export var highchartsGlobalOptions = {
  lang: {
    rangeSelectorZoom: '',
    months: longMonths,
    weekdays: weekdays,
    shortMonths: shortMonths,
    thousandsSep: '.',
    decimalPoint: ',',
    loading: 'Cargando...'
  }
};